// import React from "react";

export default function Page() {
  return <p>🚧 Construction in progress... 🏗</p>;
}
